import { combineReducers } from 'redux';

import shared from 'web-shared/reducers';

const reducer = combineReducers(shared);

export default reducer;
